import { CheckGlobalResourceAccessTask } from '@/Ship/Tasks/CheckGlobalResourceAccessTask'

import { ApplicationList } from '../Components/ApplicationList'
import { APPLICATION_RESOURCE } from '../Contracts/IApplication'

/** Значення форми власника; без `uuid` (новий запис) заявок ще немає. */
export interface ApplicationOwnerRecord {
    uuid?: unknown
    '@id'?: unknown
    title?: unknown
}

export interface ClientApplicationsTabProps {
    record: ApplicationOwnerRecord | undefined
}

/**
 * Чи бачить користувач заявки взагалі: колекційне `read_collection`. За ним
 * картка власника ховає вкладку, а не показує 403 усередині.
 */
export const canReadApplications = (): boolean => CheckGlobalResourceAccessTask(APPLICATION_RESOURCE, 'read_collection')

/** Посилання на власника з його форми — або `null`, якщо він ще не збережений. */
export const applicationOwnerOf = (record: ApplicationOwnerRecord | undefined) => {
    const uuid = typeof record?.uuid === 'string' && record.uuid !== '' ? record.uuid : null

    if (uuid === null) return null

    const iri = record?.['@id']
    const title = record?.title

    return {
        uuid,
        ...(typeof iri === 'string' && iri !== '' ? { '@id': iri } : {}),
        ...(typeof title === 'string' && title !== '' ? { title } : {}),
    }
}

/**
 * Публічне API контейнера заявок для картки клієнта (`SPEC-021` §8.9,
 * `SPEC-025` §3.5): вміст вкладки «Заявки» — префільтр клієнта, без фільтрів і
 * канбану, «Додати заявку» з підставленим клієнтом (легасі
 * `ClientFormTemplate.jsx:186-204`). Розміщує вкладку наряд оболонки (Н-025.4).
 */
export const ClientApplicationsTab = ({ record }: ClientApplicationsTabProps) => {
    const owner = applicationOwnerOf(record)

    if (owner === null || !canReadApplications()) return null

    return <ApplicationList ownerField="client" owner={owner} />
}
